import axios from "axios";
import { getToken } from "../Utlis/UpdateUserState";

const deleteDocument = async (id) => {
  try {
    const token = getToken();

    const res = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}documents/?id=${id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Document delete error:", error);
    throw error;
  }
};

export { deleteDocument };
